<template>
  <div v-if="isMyAccount || !dummy">
    <TextLabel class="">{{ label }}</TextLabel>
    <div v-if="dummy" class="row">
      <div class="col">
        {{ dummy }}&nbsp;
        <template v-if="isMyAccount && permissions.createTournament">
          <router-link
            class="purple-link"
            :to="{
              name: $routerNames.EDIT,
              params: {
                ...account.params,
                ...$route.params,
              },
              hash: '#description-accounts-edit',
            }"
            >{{
              $t('_web_profile-info_description-add-link', 'Add description')
            }}</router-link
          >
        </template>
      </div>
    </div>
    <div v-else class="row">
      <TextBlock class="text-justify col-auto" :size="0.875">
        {{ account.description }}
      </TextBlock>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

// import Wrapper from '../../PanelWrapper';
import TextLabel from '@/components/atoms/TextLabel';
import TextBlock from '@/components/atoms/TextBlock';
export default {
  name: 'AccountInfoGames',
  components: {
    TextLabel,
    TextBlock,
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccountId: 'accountId' }),
    ...mapGetters(['permissions']),

    label() {
      return this.$t('_web_profile-info_description-header', `Description`, {
        name: this.account._name,
      });
    },
    isMyAccount() {
      return this.accountId === this.myAccountId;
    },
    dummy() {
      return this.account.description
        ? null
        : this.isMyAccount
        ? this.$t(
            '_web_profile-info_no-description_my',
            'Please add some information here. Go to edit mode to do that'
          )
        : this.$t(
            '_web_profile-info_no-description',
            "User hasn't added any information here"
          );
    },
  },
};
</script>
<style lang="scss">
.purple-link {
  color: #5a58f2 !important;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
